import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {USER_TABS} from 'src/constants';

import {ActivityTags} from './activity-tags/activity-tags';
import {LcdCreditAnalysis} from './lcd-credit-analysis/lcd-credit-analysis';
import {ViewPreferences} from './view-prefernces/view-preferences';

type Props = {
    userId: number,
    accountId: number,
};

export const PersonalizationRouter = ({userId, accountId}: Props) => {

    return (
        <Routes>
            <Route
                path="/view-preferences"
                element={<ViewPreferences userId={userId} accountId={accountId}/>}
            />

            <Route
                path="/activity-tags"
                element={<ActivityTags userId={userId} accountId={accountId}/>}
            />
            <Route
                path="/lcd-credit-analysis"
                element={<LcdCreditAnalysis userId={userId} accountId={accountId}/>}
            />
            <Route
                path="*"
                element={(
                    <Navigate to={`/profile/user/${userId}/${USER_TABS.PERSONALIZATION.name}/view-preferences`}/>)}
            />
        </Routes>
    );
};
